export const parseJSON = <T extends object>(
  str: Parameters<typeof JSON.parse>[0] | null | undefined,
  receiver?: Parameters<typeof JSON.parse>[1]
): T | null => {
  if (!str) return null;

  try {
    const obj = JSON.parse(str, receiver);

    return obj as T;
  } catch (error) {
    console.error(error);
    return null;
  }
};
